import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import IconLink from '../../shared/icon-link/IconLink';
import { ReactComponent as ChevronLeftSVG } from './assets/ChevronLeft.svg';
import { useStyles } from './styles';

const MentorsPageNavigation = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box>
      <IconLink
        customClass={classes.backLink}
        to="/"
        startIcon={<Box component={ChevronLeftSVG} />}
      >
        <Typography variant="body1" className={classes.pageHeaderLink}>
          {t('v2.global.button_label_goBackToDashboard')} /
          <span className={classes.pageTitle}>
            {t('v2.mentorOverview.header_label_title')}
          </span>
        </Typography>
      </IconLink>
    </Box>
  );
};

export default MentorsPageNavigation;
